import { IOpsHubFlags, IFeatureFlags } from './common';
import opsHubFeatureFlags from './flags';
import { FeatureFlagsHelper } from '@telstra-connect/feature-flags';
import { appName } from '@telstra-connect/utils/data/ops-hub';

let helper: FeatureFlagsHelper<typeof appName>;

export const loadAppFeatureFlags = (getFlagsConfigFromState?: () => IOpsHubFlags): void => {
    helper = new FeatureFlagsHelper(appName, getFlagsConfigFromState, opsHubFeatureFlags);
};

export const getOpsHubFlags = (): IFeatureFlags => helper && helper.getFlags()
